import React, { useState } from 'react'
import Footer from '../section/footer/footer'
import { commaSeperatedAmount, CURRENCY_SYMBOL } from '../common'
import { useSelector } from 'react-redux'
import TypeOfZakat from '../section/pay-zakat/type-of-zakat'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

const QuickZakat = ({setHeaderData}) => {
    // const homepage = useSelector(state => state.homepageReducer)
    const [initialOfZakat, setInitialOfZakat] = useState(false)
    const { t } = useTranslation()

    //muisZakatHarta


    const setIsInitial = (value) => {
        setInitialOfZakat(value)
    }

    return (
        <div>
           <TypeOfZakat setIsInitial={setIsInitial} setHeaderData={setHeaderData} />
        </div>
    )
}

export default QuickZakat
